import React from 'react'
import type { BomSummary } from '@ztechapps/product.common'
import { PurchaseButtonProvider } from './Context'
import { Layout } from './Layout'

type PurchaseButtonProps = BomSummary & {
  onAfterAction?: () => void
}

export const PurchaseButton = ({ onAfterAction, product, qtyNeededToBuild }: PurchaseButtonProps) => {
  return (
    <PurchaseButtonProvider product={product} qtyNeededToBuild={qtyNeededToBuild} onAfterAction={onAfterAction}>
      <Layout />
    </PurchaseButtonProvider>
  )
}
